import http from "./http.js";

class StoreItemSyncApi {
  /**
   * Sync store items from uploaded file
   * @param {File} file - The file to upload (Excel or CSV)
   * @param {number} storeId - The store ID
   * @returns {Promise} - API response with task ID
   */
  static async syncStoreItems(file, storeId) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("store_id", storeId);

    return http.post("/v1/store/catalog/sync", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  /**
   * Get task status (if using Celery task tracking)
   * @param {string} taskId - The task ID
   * @returns {Promise} - Task status response
   */
  static async getTaskStatus(taskId) {
    return http.get(`/v1/background/tasks/${taskId}`);
  }

  /**
   * Download template file for store item sync
   * @param {string} type - Template type ('products' or 'services')
   * @returns {Promise} - Blob response
   */
  static async downloadTemplate(type = "products") {
    const response = await http.get(`/v1/store/catalog/template/${type}`, {
      responseType: "blob",
    });
    return response.data;
  }

  /**
   * Get store items for preview
   * @param {number} storeId - The store ID
   * @param {number} page - Page number
   * @param {number} limit - Items per page
   * @returns {Promise} - Store items response
   */
  static async getStoreItems(storeId, page = 1, limit = 20) {
    return http.get(`/v1/store/${storeId}/items`, {
      params: { page, limit },
    });
  }
}

export default StoreItemSyncApi;
